import * as React from 'react'
import { AlertTriangle } from 'lucide-react'
import { cn } from '@/lib/utils'

type Tone = 'warning' | 'notice'

const TONE: Record<Tone, string> = {
  // Over the allowance — the state the policy actually warns about.
  warning: 'bg-rose-50 text-rose-700 ring-rose-200 dark:bg-rose-500/10 dark:text-rose-200 dark:ring-rose-500/25',
  // Would go over if submitted/approved — a heads-up, not a breach yet.
  notice: 'bg-amber-50 text-amber-800 ring-amber-200 dark:bg-amber-500/10 dark:text-amber-200 dark:ring-amber-500/25',
}

interface AllowanceWarningProps {
  message: string
  tone?: Tone
  className?: string
}

/** Monthly WFH / leave allowance warning banner. See src/lib/allowance.ts. */
export function AllowanceWarning({ message, tone = 'warning', className }: AllowanceWarningProps) {
  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-2.5 rounded-xl px-3.5 py-3 text-sm font-medium ring-1 ring-inset',
        TONE[tone],
        className
      )}
    >
      <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
      <p>{message}</p>
    </div>
  )
}
